"use client"

import withWatchlist from "src/components/filmwebid/withWatchlist";
import TrailerPoster from "src/components/trailerposter/TrailerPoster";
import YoutubeTrailerPoster from "src/components/trailerposter/YoutubeTrailerPoster";

const TrailerPosterWithWatchlist = withWatchlist(TrailerPoster, "movieClip");

export default TrailerPosterWithWatchlist;

export const YoutubeTrailerPosterWithWatchlist = withWatchlist(YoutubeTrailerPoster, "film");